import { FC } from 'react';
import { HsCodeFieldProps } from './types';
import { SearchByNameField } from './SearchByNameField';
import { SearchByCodeField } from './SearchByCodeField';
import { ManualField } from './ManualField';
import { CustomField } from './CustomField';

export const HsCodeField: FC<HsCodeFieldProps> = ({ mode, ...props }) => {
	switch (mode) {
		case 'search-by-name':
			return <SearchByNameField {...props} />;
		case 'search-by-code':
			return <SearchByCodeField {...props} />;
		case 'manual':
			return <ManualField {...props} />;
		case 'custom':
			return <CustomField {...props} />;
		default:
			return null;
	}
};

export * from './types';
export * from './SearchByNameField';
export * from './SearchByCodeField';
export * from './ManualField';
export * from './CustomField';
